import axios from '../lib/AxApi';

export default {
    async getWikiByName(wikiName)
    {
        let val;
        try
        {
            const response = await axios.get('/wiki/getWikiByName', {
                params: {
                    wikiName,
                },
            });

            val = response.data;
            return val;
        }
        catch (e)
        {
            val = { error: true, notice: e.toString() };
            return val;
        }
    },
};
